import axios from "axios";
import { createContext , useEffect, useState} from "react";
import {API} from '../constants/API';
import { MESSAGES } from "../data/message";
import api from '../services/axisoHttp';

interface ChildrenNode {
    children: React.ReactNode
}

const MessageContext = createContext({
  chat: {},
  setChat: (chat: any) => {},
  chatLogs: {},
  setChatLogs: (chatLogs: any) => {},
});


export const MessageProvider = ({children}: ChildrenNode)=> {
      const [chatLogs , setChatLogs] : any = useState([]);
      const [chat , setChat] : any = useState({});

    useEffect(()=> {



        setChatLogs(MESSAGES);
        setChat(MESSAGES[MESSAGES.length - 1]);

        const fetchMessages = async ()=>{
            try{
                const response = await axios.get(API.MESSAGES)
                if(response && response.data) {
                    let chats = response.data;
                    setChatLogs(chats);
                    // Default chat selection
                    setChat(chats[chats.length - 1]);
                }
            } catch(err){
                // Not in the 200 response
                console.log(err)
            }
        }
        
        // fetchMessages()
    }, [])

    return (
      <MessageContext.Provider
        value={{
          chatLogs,
          setChatLogs,
          chat,
          setChat,
        }}
      >
        {children}
      </MessageContext.Provider>
    );

}


export default MessageContext;